<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.ID?'编辑文件':'新增文件'"
      height="340px"
      width="650px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form :model="formData"
               label-width="auto"
               :rules="rules"
               class="el-form-box" ref="ruleFormRef">
        <el-row :gutter="10">

          <el-col :span="15" >
            <el-form-item label="文件名称：" prop="Name">
              <el-input v-model.trim="formData.Name" placeholder="请输入文件名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="" prop="Year" >
              <el-select v-model="formData.Year">
                <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <el-form-item label="文件链接：" prop="Link" >
              <el-input v-model.trim="formData.Link" placeholder="请直接输入链接或上传文件后获取链接"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="" prop="" >
              <el-upload
                  v-loading="fileListUploading"
                  style="display: inline-block"
                  v-model:file-list="fileList"
                  :show-file-list="false"
                  :headers="uploadData"
                  :action="VUE_APP_uploadurl"
                  :before-upload="beforeUpload"
                  :on-exceed="masterFileMax"
                  :on-success="handleUploadSuccess"
                  :on-error="handleUploadError"
                  :on-change="fileUploadChange"
              >
                <el-button type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
<!--        <el-button @click="handleClose">取消</el-button>-->
<!--         修改-->
         <el-button v-if="formData.ID" type="primary" @click="save(ruleFormRef,true)"
                    :loading = "loading"
         >保存</el-button>
        <!--         保存-->
        <el-button v-if="!formData.ID" type="primary" @click="save(ruleFormRef,true)"
                   :loading = "loading"
        >保存并关闭</el-button>
        <!--         保存-->
         <el-button v-if="!formData.ID" type="primary" @click="save(ruleFormRef,false)"
                    :loading = "loading"
         >保存并继续上传</el-button
         >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm} from "@/utils/formValidate";
import {getYears} from "@/utils/commonSetting"
import {getToken} from "@/utils/token";
import {addDoc, updateDoc} from "@/api/docsAdmin";
import {getCleanFileName} from "@/utils/dealFileName";
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()
const YEARS = getYears()
const VUE_APP_uploadurl = process.env.VUE_APP_uploadurl
const uploadData = ref({key:"",Authorization:`Bearer ${getToken()}`})
const fileList = ref([])
const fileListUploading = ref(false)
var formData = reactive({
  ID:null,
  Link:null, // 链接
  Name: null, // 名称
  Year:new Date().getFullYear(),// 年份
})
const loading = ref(false)
const rules = ({
  Name: [{required: true, message: '请输入文件名称', trigger: ['blur']}],
  Year: [{required: true, message: '请选择年份', trigger: [ 'blur']}],
  Link:[{required: true, message: '请输入文件链接或上传文件', trigger: ['blur']}],
})

const props = defineProps({
  item: {
    default: {},
  },
  numbers:{
    default:5
  }
})
// 开始
onMounted(()=>{
  if(props.item && props.item.ID){
    formData.ID = props.item.ID
    formData.Name = props.item.Name
    formData.Year = props.item.Year
    formData.Link = props.item.Link
  }
})

const handleClose = () => {
  emits("close", true)
}
// 保存
const save = async (ruleFormRef,isClose) => {
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    Role:formData.isMainRole?1:2
  }
  if( formData.ID){
    res = await updateDoc(params)
    messPre = '修改'
  }else{
    res = await addDoc(params)
    messPre = '创建'
  }
  loading.value = false
  if(res.success){
    ElMessage.success(messPre + "成功")
    if(isClose){
      emits("success", {updata:true,close:true})
    }else{
      // 更新表单
      formData.Link = ""
      formData.Name = ""
      emits("success", {updata:true,close:false})
    }
  }else{
    ElMessage.warning(res.err_msg || messPre + "失败")
  }

}
// 上传之前判断
const beforeUpload = async(file)=>{
  if(file.name){
    formData.Name =  getCleanFileName(file.name)
  }
  return true
  // const isJPGOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  // const isLt30M = file.size / 1024 / 1024 < 30;
  // if (!isJPGOrPng) {
  //   ElMessage.error('请上传jpeg或png格式的图片!');
  // }
  // if (!isLt30M) {
  //   ElMessage.error('照片不能大于30MB!');
  // }
  // if(!isJPGOrPng || !isLt30M){
  //   return false
  //   // fileLists.pop(0,fileLists.length - 1)
  // }else{
  //   return true
  // }

}
const fileUploadChange = (e)=>{
  if(e.status === "ready"){
    fileListUploading.value = true
  }else if(e.status === "fail"){
    fileListUploading.value = false
  }
  else if(e.status === "success"){
    fileListUploading.value = false
  }
  console.log("fileUploadChange",e)
}
const masterFileMax = () => {ElMessage.warning("文件超出限制！")}
const handleUploadError= (err)=>{
  ElMessage.error("上传失败")}
const handleUploadSuccess = (res)=>{
  if(res.err_code===0 && res.data){
    formData.Link = res.data
  }else{
    return ElMessage.error("文件上传失败")
  }
}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  height: 120px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
